import PlaceholderPage from '../../components/feature/PlaceholderPage';

export default function TestEmailPage() {
  return (
    <PlaceholderPage
      title="Test Email"
      icon="ri-send-plane-line"
      description="Send a test email to verify your XeroVerifier email integration is working correctly."
    />
  );
}
